import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import {
  PESQUISA_EMPRESAS,
  PESQUISA_CONTRATOS_POR_EMPRESA,
} from '../../../../services/permissoesRecebidas.js';
import useFetch from '../../../../components/hooks/useFetch.js';
import { useLocation, useNavigate } from 'react-router-dom';
import './TelaPermissoesRecebidas.scss';
import Select from '../../../../components/form/Select.js';
import { format } from 'date-fns';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import FormExcluirCartaoPostagem from './FormExcluirCartaoPostagem.js';
import FormExcluirCentroCusto from './FormExcluirCentroCusto.js';
import FormExcluirContrato from './FormExcluirContrato.js';

const TelaPermissoesRecebidasContratos = () => {
  const { t } = useTranslation();
  const { register, handleSubmit, errors, control } = useForm();
  const {
    request: requestPermissoesRecebidas,
    data: dadosPermissoesRecebidas,
  } = useFetch();
  const { request: requestEmpresas, data: dadosEmpresas } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const navigate = useNavigate();
  const [modalAbertoExcluirCartaoPostagem, setModalAbertoExcluirCartaoPostagem] = useState(false);
  const [modalAbertoExcluirCentroCusto, setModalAbertoExcluirCentroCusto] = useState(false);
  const [modalAbertoExcluirContrato, setModalAbertoExcluirContrato] = useState(false);
  const [contratoSelecionado, setContratoSelecionado] = useState();
  const [cartaoPostagemSelecionado, setCartaoPostagemSelecionado] = useState();
  const [centroCustoSelecionado, setCentroCustoSelecionado] = useState();
  const [idCorreiosPJSelecionado, setIdCorreiosPJSelecionado] = useState();
  const [alterei, setAlterei] = useState(false);

  useEffect(() => {
    if (dados.idCorreios && dados.idCorreios != '') {
      requestEmpresas(PESQUISA_EMPRESAS(dados.idCorreios));
    } else navigate('/login');
  }, [dados]);

  const handleEscolherEmpresa = (event) => {
    let idCorreiosPJ = event.target.value;
    if (idCorreiosPJ){
      setIdCorreiosPJSelecionado(idCorreiosPJ);
      requestPermissoesRecebidas(
        PESQUISA_CONTRATOS_POR_EMPRESA(dados.idCorreios, idCorreiosPJ),
      );
    }
  };

  const abreModalExcluirCartaoPostagem = (contrato, cartaoPostagem) => {
    setContratoSelecionado(contrato);
    setCartaoPostagemSelecionado(cartaoPostagem);
    setModalAbertoExcluirCartaoPostagem(true);
  };

  const abreModalExcluirCentroCusto = (contrato, centroCusto) => {
    setContratoSelecionado(contrato);
    setCentroCustoSelecionado(centroCusto);
    setModalAbertoExcluirCentroCusto(true);
  };

  const abreModalExcluirContrato = (contrato) => {
    setContratoSelecionado(contrato);
    setModalAbertoExcluirContrato(true);
  };

  const fechar = () => {
    setAlterei(true);
    setModalAbertoExcluirCartaoPostagem(false);
    setModalAbertoExcluirCentroCusto(false);
    setModalAbertoExcluirContrato(false);
  };

  useEffect(() => {
    if (dados.idCorreios && dados.idCorreios != '' && idCorreiosPJSelecionado && idCorreiosPJSelecionado != ''){
      requestPermissoesRecebidas(
        PESQUISA_CONTRATOS_POR_EMPRESA(dados.idCorreios, idCorreiosPJSelecionado),
      );
    }
      setAlterei(false);
  }, [alterei]);

  return (
    <>
      <div className="conteudo permissoes-recebidas">
        <h1>{t('principal.received_permissions.contracts_title')}</h1>

        <Select
          options={
            dadosEmpresas
              ? [
                  { label: t('principal.received_permissions.select_company'), value: '' },
                  ...dadosEmpresas.map((item) => ({
                    value: item.idCorreios,
                    label: item.nome,
                  })),
                ]
              : [{ label: t('principal.received_permissions.select_company'), value: '' }]
          }
          name="empresa"
          inputref={register}
          errors={errors}
          //label="Empresas"
          id="idCorreiosPJ"
          onChange={handleEscolherEmpresa}
        />

        <div className="cards-container visualizar-contratos">
          {dadosPermissoesRecebidas?.length === 0 && (
            <h6>{t('principal.received_permissions.no_contracts_found')}</h6>
          )}

          {dadosPermissoesRecebidas?.map((contrato) => (
            <>
              <div className="contrato" key={contrato.nuContrato}>
                <div className="info-contrato">
                  <div>
                    <h6>Contrato nº {contrato.nuContrato}</h6>
                    <small>
                      {/*<b>Categoria: </b>*/} {contrato.contrato.categoria ? contrato.contrato.categoria: " "}
                      <b> Vigência: </b>
                      {contrato.contrato.dtInicioVigencia
                      ? format(new Date(contrato.contrato.dtInicioVigencia),'dd/MM/yyyy')
                      :''}
                      -
                      {contrato.contrato.dtFimVigencia
                      ? format(new Date(contrato.contrato.dtFimVigencia),'dd/MM/yyyy')
                      :''}
                    </small>
                  </div>
                  <button 
                    className='btn-txt so-icone' 
                    title='Excluir Contrato'
                    onClick={() => abreModalExcluirContrato(contrato)}>
                      <i className='ic-lixo'></i>
                  </button>
                </div>

                {contrato.listaPermissaoCentroCustoResponse?.map(
                  (centroCusto) => (
                    <>
                      <div
                        className="centro-custo bg-superficie"
                        key={centroCusto.nuCentroCusto}
                      >
                        <p className="subtitulo-base nome-centro">
                          <b>Centro de custo: {centroCusto.nuCentroCusto}</b>
                          <button 
                            className='btn-txt so-icone' 
                            title='Excluir Centro Custo'
                            onClick={() => abreModalExcluirCentroCusto(contrato, centroCusto)}
                            >
                              <i className='ic-lixo'></i>
                          </button>
                        </p>
                        
                        <hr />
                        {centroCusto.listaPermissaoCartaoPostagemResponse?.map(
                          (cartao) => (
                            <>
                              <div
                                className="cartao-postagem"
                                key={cartao.nuCartaoPostagem}
                              >
                                <small className="cartao">
                                  {cartao.nuCartaoPostagem}
                                </small>
                                <small className="status-cartao legenda ativo">
                                  {cartao.status}
                                </small>
                                <button 
                                  className='btn-txt so-icone'
                                  onClick={() => abreModalExcluirCartaoPostagem(contrato, cartao)}>
                                    <i className='ic-lixo'></i>
                                </button>
                              </div>
                              
                            </>
                          ),
                        )}
                      </div>
                    </>
                  ),
                )}
              </div>
              <hr />
            </>
          ))}
        </div>

        <button className="btn-pre" onClick={() => navigate('/principal')}>
          {t('principal.forms.buttons.back')}
        </button>
      </div>

      <ModalDialog
        id="modal-excluir-cartao-postagem"
        aberto={modalAbertoExcluirCartaoPostagem}
        setAberto={setModalAbertoExcluirCartaoPostagem}
        opcaoFechar={true}
      >
        <FormExcluirCartaoPostagem
          acaoCancelar={() => setModalAbertoExcluirCartaoPostagem(false)}
          acaoFechar={fechar}
          idCorreios={dados.idCorreios}
          idCorreiosPJ={idCorreiosPJSelecionado}
          cartaoPostagemSelecionado={cartaoPostagemSelecionado}
          contratoSelecionado={contratoSelecionado}
        />
      </ModalDialog>

      <ModalDialog
        id="modal-excluir-centro-custo"
        aberto={modalAbertoExcluirCentroCusto}
        setAberto={setModalAbertoExcluirCentroCusto}
        opcaoFechar={true}
      >
        <FormExcluirCentroCusto
          acaoCancelar={() => setModalAbertoExcluirCentroCusto(false)}
          acaoFechar={fechar}
          idCorreios={dados.idCorreios}
          idCorreiosPJ={idCorreiosPJSelecionado}
          centroCustoSelecionado={centroCustoSelecionado}
          contratoSelecionado={contratoSelecionado}
        />
      </ModalDialog>

      <ModalDialog
        id="modal-excluir-contrato"
        aberto={modalAbertoExcluirContrato}
        setAberto={setModalAbertoExcluirContrato}
        opcaoFechar={true}
      >
        <FormExcluirContrato
          acaoCancelar={() => setModalAbertoExcluirContrato(false)}
          acaoFechar={fechar}
          idCorreios={dados.idCorreios}
          idCorreiosPJ={idCorreiosPJSelecionado}
          contratoSelecionado={contratoSelecionado}
        />
      </ModalDialog>
    </>
  );
};

export default TelaPermissoesRecebidasContratos;
